// Adressfelder für Liefer- und Rechnungsadresse — Checkout und Einstellungen.
//
// `section` ('shipping' | 'billing') ist zugleich Präfix der Feldnamen, damit
// beide Blöcke im selben <Form> stehen können (`shipping_zip`,
// `billing_zip`), und Autofill-Sektion: der Browser füllt Liefer- und
// Rechnungsadresse getrennt aus.

const FIELDS = [
  { name: 'firstName', label: 'Vorname', autoComplete: 'given-name', span: 'half' },
  { name: 'lastName', label: 'Nachname', autoComplete: 'family-name', span: 'half' },
  { name: 'company', label: 'Firma (optional)', autoComplete: 'organization', span: 'full' },
  { name: 'address', label: 'Adresse', autoComplete: 'street-address', span: 'full' },
  { name: 'city', label: 'Stadt', autoComplete: 'address-level2', span: 'half' },
  { name: 'country', label: 'Land', autoComplete: 'country-name', span: 'half' },
  { name: 'zip', label: 'Postleitzahl', autoComplete: 'postal-code', span: 'half' },
  { name: 'phone', label: 'Telefonnummer', autoComplete: 'tel', span: 'half' },
];

export const ADDRESS_FIELD_NAMES = FIELDS.map((field) => field.name);

// Beide Seiten behalten ihr bisheriges Aussehen.
const VARIANTS = {
  checkout: {
    grid: 'grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-4',
    half: '',
    full: 'sm:col-span-2',
    label: 'block text-sm font-medium text-gray-700',
    wrapper: 'mt-1',
    input:
      'block w-full rounded-md border-gray-300 shadow-xs focus:border-svisit-primary-500 focus:ring-svisit-primary-500 sm:text-sm disabled:cursor-not-allowed',
  },
  settings: {
    grid: 'grid grid-cols-1 gap-x-6 gap-y-8 sm:max-w-xl sm:grid-cols-6',
    half: 'sm:col-span-3',
    full: 'col-span-full',
    label: 'block text-sm font-medium leading-6 text-gray-900',
    wrapper: 'mt-2',
    input:
      'block w-full rounded-md border-0 bg-white/5 px-3 py-1.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-svisit-primary-500 sm:text-sm sm:leading-6',
  },
};

/**
 * Liest die Felder einer Sektion aus `Object.fromEntries(formData)` in die
 * Form, die der Server erwartet (`{ firstName, …, phone }`).
 */
export const readAddressFields = (data, section) =>
  Object.fromEntries(
    ADDRESS_FIELD_NAMES.map((name) => [name, data[`${section}_${name}`] ?? ''])
  );

const AddressFields = ({
  section,
  defaults,
  required = [],
  disabled = false,
  variant = 'checkout',
}) => {
  const styles = VARIANTS[variant];

  return (
    <div className={styles.grid}>
      {FIELDS.map((field) => {
        const id = `${section}-${field.name}`;
        const common = {
          id,
          name: `${section}_${field.name}`,
          autoComplete: `${section} ${field.autoComplete}`,
          className: styles.input,
          required: required.includes(field.name),
          disabled,
        };
        return (
          <div key={field.name} className={styles[field.span]}>
            <label htmlFor={id} className={styles.label}>
              {field.label}
            </label>
            <div className={styles.wrapper}>
              {field.name === 'country' ? (
                // Versand bisher nur in die Schweiz.
                <select {...common} defaultValue="Schweiz">
                  <option>Schweiz</option>
                </select>
              ) : (
                <input
                  {...common}
                  type={field.name === 'phone' ? 'tel' : 'text'}
                  defaultValue={defaults?.[field.name] ?? ''}
                />
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AddressFields;
